import React from "react";
import { Link } from "react-router-dom";
import TodoList from "../components/Home/TodoList";
import "./Demo.css";

export const Demo = () => {
  return (
    <main className="demo-page">
      <section className="demo-intro">
        <p className="demo-eyebrow">Interactive demo</p>
        <h1>Stop deciding. Pick your next task.</h1>
        <p>
          Add a task or use the sample list. Try Random when you feel stuck,
          Start for a focused Pomodoro session, or Flow for open-ended work.
        </p>
      </section>

      <TodoList />

      <section className="demo-signup-callout">
        <h2>Ready to use it for your real day?</h2>
        <p>Create a free account to save your tasks and keep your list moving.</p>
        <Link to="/signup">Start Free</Link>
      </section>
    </main>
  );
};
